// Session tokens are opaque, so the signed-in user's role and permissions come from the
// user object returned at sign-in (and refreshed from /users/me), kept in localStorage.
export interface SessionUser {
  id: number;
  username: string;
  fullName: string;
  email: string;
  role: string;
  status?: string;
  doctorId?: number | null;
  [key: string]: unknown;
}

const TOKEN_KEY = 'token';
const ROLE_KEY = 'userRole';
const USER_KEY = 'clinix:user';

export function saveSessionUser(user: SessionUser) {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
  localStorage.setItem(ROLE_KEY, String(user.role ?? ''));
}

export function saveSession(token: string, user?: SessionUser | null) {
  localStorage.setItem(TOKEN_KEY, token);
  if (user) saveSessionUser(user);
}

export function readSessionUser(): SessionUser | null {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) as SessionUser : null;
  } catch {
    return null;
  }
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(ROLE_KEY);
  localStorage.removeItem(USER_KEY);
}

// Claim-shaped view of the stored user, using the key names the old JWT payload exposed
// (role, UserId, DoctorId, CanEditPayments, ...). Values are strings, as JWT claims were.
export function sessionClaims(): Record<string, string> {
  const user = readSessionUser();
  const claims: Record<string, string> = {};
  if (user) {
    for (const [key, value] of Object.entries(user)) {
      claims[key.charAt(0).toUpperCase() + key.slice(1)] = value == null ? '' : String(value);
    }
  }
  claims.role = String(user?.role ?? localStorage.getItem(ROLE_KEY) ?? '');
  claims.UserId = user ? String(user.id) : '';
  return claims;
}
